module.exports = __webpack_public_path__ + "a125b72414e7d86b930eefcc41ca580f.fbx";